export default __webpack_public_path__ + "static/media/sweet3.4e38111b.jpg";